import { jsxs as t, jsx as a, Fragment as R } from "react/jsx-runtime";
import "react";
import { classNames as r } from "../../utilities/index.js";
import S from "../Button/index.js";
import P from "../Image/index.js";
const _ = _ref => {
    let {
      image: h,
      hoverImage: n,
      productLine: o,
      productName: m,
      price: s,
      showPrice: v = !0,
      rating: i,
      featured: d,
      pricingText: x,
      promo: g,
      noPriceText: f,
      children: y,
      className: p,
      link: l,
      linkComponent: c,
      isGatsby: b = !1,
      layout: e = "vertical",
      buttonText: T = "View Details",
      buttonColor: z = "primary-alt",
      startingAt: u,
      ...$
    } = _ref;
    const F = r({
        "sash-ProductTile flex flex-col relative bg-white border border-gray-42 h-full transition-shadows duration-200": !0,
        "sash-ProductTile--vertical p-5 md:p-6": e === "vertical",
        "grid grid-cols-[89px_1fr] md:grid-cols-[124px_1fr] grid-flow-row p-3 md:p-4 gap-x-2 md:gap-x-3 grid-rows-[1fr_minmax(0,max-content)]": e === "horizontal",
        "!no-underline hover:shadow-md": l,
        group: n,
        [p]: p
      }),
      L = r({
        "sash-ProductTile-Image text-center": !0,
        "mb-4": e === "vertical",
        "col-span-1 row-span-1": e === "horizontal",
        grid: n
      }),
      N = r({
        "mx-auto": !0,
        "h-[180px]": e === "vertical",
        "col-start-1 row-start-1": n
      }),
      C = r({
        "sash-ProductTile-Content": !0,
        "flex flex-col h-full": e === "vertical",
        "col-span-1 row-span-1": e === "horizontal"
      }),
      V = r({
        "sash-ProductTile-CTA mt-auto pt-3": !0,
        "col-span-full row-span-1": e === "horizontal"
      }),
      w = r({
        "sash-ProductTile-Price font-semibold leading-relaxed m-0": !0,
        "text-base md:text-lg": e === "horizontal",
        "text-lg": e === "vertical"
      }),
      j = r({
        "sash-ProductTile-OrigPrice my-0": !0,
        "text-gray-60 line-through": s == null ? void 0 : s.pro,
        "font-semibold leading-relaxed": !(s != null && s.pro),
        "text-xs md:text-sm ml-2": (s == null ? void 0 : s.pro) && e === "horizontal",
        "ml-2.5": (s == null ? void 0 : s.pro) && e === "vertical",
        "text-base md:text-lg": !(s != null && s.pro) && e === "horizontal",
        "text-lg": !(s != null && s.pro) && e === "vertical"
      });
    return /* @__PURE__ */t(l && c ? c : l && !c ? "a" : "div", {
      className: F,
      href: !b && l ? l : null,
      to: b && l ? l : null,
      ...$,
      children: [h && /* @__PURE__ */t("div", {
        className: L,
        children: [/* @__PURE__ */a(P, {
          src: h,
          alt: `${o} ${m}`,
          className: `${N} group-hover:opacity-0`,
          objectFit: "contain",
          aspectRatio: "3/2"
        }), n && /* @__PURE__ */a(P, {
          src: n,
          alt: `${o} ${m}`,
          className: `${N} opacity-0 group-hover:opacity-100`,
          objectFit: "contain",
          aspectRatio: "3/2"
        })]
      }), /* @__PURE__ */t("div", {
        className: C,
        children: [o && /* @__PURE__ */a("p", {
          className: "sash-ProductTile-ProductLine mb-0.5 text-xs font-bold uppercase leading-tight tracking-2px",
          children: o
        }), m && /* @__PURE__ */a("p", {
          className: `sash-ProductTile-ProductName mb-1 mt-0 inline-block ${e === "horizontal" ? "text-sm" : ""}`,
          children: m
        }), (i || d) && /* @__PURE__ */t("div", {
          className: `flex ${e === "horizontal" ? "mb-3 flex-col items-start [&>p]:mt-1.5" : "mb-1.5 mt-1 flex-row items-center justify-between"}`,
          children: [i && /* @__PURE__ */t("div", {
            className: "sash-ProductTile-Rating relative mr-1 grid grid-cols-1 grid-rows-1",
            children: [/* @__PURE__ */t("div", {
              className: "col-span-full row-span-full flex flex-nowrap",
              children: [/* @__PURE__ */a("span", {
                className: "material-symbols-sharp text-sm leading-none",
                children: "star"
              }), /* @__PURE__ */a("span", {
                className: "material-symbols-sharp text-sm leading-none",
                children: "star"
              }), /* @__PURE__ */a("span", {
                className: "material-symbols-sharp text-sm leading-none",
                children: "star"
              }), /* @__PURE__ */a("span", {
                className: "material-symbols-sharp text-sm leading-none",
                children: "star"
              }), /* @__PURE__ */a("span", {
                className: "material-symbols-sharp text-sm leading-none",
                children: "star"
              })]
            }), /* @__PURE__ */t("div", {
              className: "col-span-full row-span-full flex flex-nowrap overflow-hidden",
              style: {
                width: i / 5 * 100 + "%"
              },
              children: [/* @__PURE__ */a("span", {
                className: "material-symbols-sharp text-sm leading-none",
                style: {
                  fontVariationSettings: "'FILL' 1"
                },
                children: "star"
              }), /* @__PURE__ */a("span", {
                className: "material-symbols-sharp text-sm leading-none",
                style: {
                  fontVariationSettings: "'FILL' 1"
                },
                children: "star"
              }), /* @__PURE__ */a("span", {
                className: "material-symbols-sharp text-sm leading-none",
                style: {
                  fontVariationSettings: "'FILL' 1"
                },
                children: "star"
              }), /* @__PURE__ */a("span", {
                className: "material-symbols-sharp text-sm leading-none",
                style: {
                  fontVariationSettings: "'FILL' 1"
                },
                children: "star"
              }), /* @__PURE__ */a("span", {
                className: "material-symbols-sharp text-sm leading-none",
                style: {
                  fontVariationSettings: "'FILL' 1"
                },
                children: "star"
              })]
            })]
          }), d && /* @__PURE__ */t("p", {
            className: "sash-ProductTile-Featured inline-flex items-center border border-gray-60 bg-gray-10 px-2 py-px text-xs font-semibold text-gray-70",
            children: [/* @__PURE__ */a("span", {
              className: "material-symbols-sharp mr-1 text-xs leading-none",
              children: "auto_awesome"
            }), d]
          })]
        }), v && (s == null ? void 0 : s.consumer) && /* @__PURE__ */t(R, {
          children: [x && /* @__PURE__ */a("p", {
            className: `sash-ProductTile-Type my-1 font-semibold uppercase leading-tight ${e === "horizontal" ? "text-[10px]" : "text-xs"}`,
            children: /* @__PURE__ */a("span", {
              className: "inline-block bg-primary px-2 py-0.5",
              children: x
            })
          }), /* @__PURE__ */t("div", {
            className: "flex flex-row flex-wrap items-center",
            children: [u && /* @__PURE__ */a("p", {
              className: `${e === "horizontal" ? "max-w-full flex-12/12 text-xs" : `${w}`} mr-1`,
              children: u
            }), (s == null ? void 0 : s.pro) && /* @__PURE__ */a("p", {
              className: w,
              children: s.pro
            }), (s == null ? void 0 : s.consumer) && /* @__PURE__ */a("p", {
              className: j,
              children: s.consumer
            })]
          })]
        }), !(s != null && s.consumer) && f && /* @__PURE__ */a("p", {
          className: "sash-ProductTile-NoPrice mt-auto pt-1 text-xs capitalize text-gray-60",
          children: f
        }), g && /* @__PURE__ */a("p", {
          className: "sash-ProductTile-Promo text-xs font-bold uppercase text-red",
          children: g
        }), y]
      }), l && /* @__PURE__ */a("div", {
        className: V,
        children: /* @__PURE__ */a(S, {
          color: z,
          className: `py-2 ${e === "horizontal" ? "!text-xs" : ""}`,
          size: "sm",
          wide: !0,
          children: T
        })
      })]
    });
  },
  E = _;
export { E as default };